import type { EditorState } from '../types';

export const resizeCapsuleTransition = ({
  state,
  transitionId,
  durationInFrames,
}: {
  state: EditorState;
  transitionId: string;
  durationInFrames: number;
}): EditorState => {
  const { items, transitions } = state.undoableState;
  const transition = transitions[transitionId];

  if (
    !transition ||
    transition.transitionType !== 'capsuleCover' ||
    transition.durationInFrames === durationInFrames
  ) {
    return state;
  }

  const sourceItem = items[transition.sourceItemId];
  const targetItem = items[transition.targetItemId];
  if (!sourceItem || !targetItem) return state;

  const durationDelta = durationInFrames - transition.durationInFrames;
  const rippleStart = targetItem.from;
  const shiftedItemIds = new Set<string>();
  const nextItems = { ...items };

  Object.values(items).forEach((item) => {
    if (item.id === sourceItem.id) {
      nextItems[item.id] = {
        ...item,
        durationInFrames: item.durationInFrames + durationDelta,
      };
      return;
    }

    if (item.from >= rippleStart) {
      shiftedItemIds.add(item.id);
      nextItems[item.id] = {
        ...item,
        from: item.from + durationDelta,
      };
    }
  });

  const nextTransitions = Object.fromEntries(
    Object.entries(transitions).map(([id, item]) => {
      if (id === transitionId) {
        return [
          id,
          {
            ...item,
            durationInFrames,
          },
        ];
      }

      if (
        shiftedItemIds.has(item.sourceItemId) ||
        shiftedItemIds.has(item.targetItemId)
      ) {
        return [
          id,
          {
            ...item,
            from: item.from + durationDelta,
          },
        ];
      }

      return [id, item];
    }),
  );

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      items: nextItems,
      transitions: nextTransitions,
    },
  };
};
